<app-alert></app-alert>

<div class="row mt-2">
    <div class="form-group col mb-n1">
        <h1>Products</h1>
    </div>
    <div class="form-group col mb-n1 flx-center">
        <a class="btn btn-primary btn-sm float-right" [routerLink]="['/product-list/product-new']">New Product</a>
    </div>
</div>

<div class="card mb-3 mt-2">
    <div class="card-body bg-light p-3">
        <div class="input-group input-group-sm w-lg-50">
            <div class="input-group-prepend">
                <span class="input-group-text bg-secondary text-light">Filter</span>
            </div>
            <input class="form-control" placeholder="Search" type="text" autofocus="autofocus" (keyup)="tableFiltring($event)" />
        </div>
    </div>
</div>

<ngx-datatable
    #table
    class="bootstrap-table"
    [rows]="items"
    [headerHeight]="61"
    [footerHeight]="38"
    [rowHeight]="'auto'"
    [columnMode]="'standard'"
    [scrollbarH]="true"
    [count]="totalItems"
    [offset]="0"
    [limit]="20"
>
    <ngx-datatable-column name="Product Name" prop="productName" [cellClass]="'tb-col-4'" [headerClass]="'tb-col-4'" [draggable]="false" [resizeable]="false">
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            <div>
                <a [routerLink]="['/product-list/product-edit', row.productId]">
                    {{ value }}
                </a>
                <span class="badge badge-success table-badge" *ngIf="row.isPublished"> Published </span>
                <span class="badge badge-primary table-badge" *ngIf="!row.isPublished"> Draft </span>
            </div>
            <div class="cells-mobile">
                <div class="cell-value-line">{{ row.sectionName }}</div>
                <div class="cell-value-line">{{ row.price | number: '1.2-2' }}</div>
                <div class="cell-value-line">{{ row.hasOffer ? 'Yes' : 'No' }}</div>
            </div>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
        name="Section"
        prop="sectionName"
        [cellClass]="'tb-col-4 mobile-hide'"
        [headerClass]="'tb-col-4 mobile-hide'"
        [draggable]="false"
        [resizeable]="false"
    >
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            {{ value }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
        name="Price"
        prop="price"
        [cellClass]="'tb-col-4 mobile-hide'"
        [headerClass]="'tb-col-4 mobile-hide'"
        [draggable]="false"
        [resizeable]="false"
    >
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            {{ value | number: '1.2-2' }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
        name="Has Offer"
        prop="hasOffer"
        [cellClass]="'tb-col-4 mobile-hide'"
        [headerClass]="'tb-col-4 mobile-hide'"
        [draggable]="false"
        [resizeable]="false"
    >
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            {{ value ? 'Yes' : 'No' }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
        name="Order"
        prop="index"
        [cellClass]="'tb-col-2 mobile-hide'"
        [headerClass]="'tb-col-2 mobile-hide'"
        [draggable]="false"
        [resizeable]="false"
    >
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            <div>
                <span>{{ value }}</span>
            </div>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
        [cellClass]="'actions-cell tb-col-4'"
        [headerClass]="'actions-cell tb-col-4 has-filter'"
        [draggable]="false"
        [resizeable]="false"
        [sortable]="false"
    >
        <ng-template let-column="column" ngx-datatable-header-template>
            <select
                [formControl]="filterContent"
                class="selectpicker show-tick"
                data-live-search="true"
                data-header="Filter by content type"
                data-selected-text-format="static"
                title="Content Type"
                data-width="fit"
                data-container="body"
                data-style="btn-sm"
            >
                <option>All Content Types</option>
                <option [value]="item.sectionId" *ngFor="let item of sections">{{ item.sectionName }}</option>
            </select>
        </ng-template>
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            <div class="btn-group ml-2" ngbDropdown container="body">
                <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" ngbDropdownToggle>Actions</button>
                <div class="dropdown-menu" ngbDropdownMenu>
                    <a class="dropdown-item btn-sm" *ngIf="!row.isPublished" (click)="confirmTogglePublish(row, true)" ngbDropdownItem>Publish</a>
                    <a class="dropdown-item btn-sm" *ngIf="row.isPublished" (click)="confirmTogglePublish(row, false)" ngbDropdownItem>Unpublish</a>
                    <a class="dropdown-item btn-sm" (click)="confirmDelete(row)" ngbDropdownItem>Delete</a>
                </div>
            </div>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-footer>
        <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-curPage="curPage">
            <datatable-pager
                [pagerLeftArrowIcon]="'datatable-icon-left'"
                [pagerRightArrowIcon]="'datatable-icon-right'"
                [pagerPreviousIcon]="'datatable-icon-prev'"
                [pagerNextIcon]="'datatable-icon-skip'"
                [page]="curPage"
                [size]="pageSize"
                [count]="rowCount"
                [hidden]="!(rowCount / pageSize > 1)"
                (change)="table.onFooterPage($event)"
            >
            </datatable-pager>
        </ng-template>
    </ngx-datatable-footer>
</ngx-datatable>
